// Each of these values is the unique id in the embed url corresponding to a particular page created in canva. CanvaEmbed.jsx component uses these to render an iframe

export const canvaMappings = {
  introToAda: "DAGvOX9a-ds/51-j94Rae-6bbi1MDypIIA",
  dashboard: "DAGxSWvosVs/K4nTaQiAwYoZ1EEXvlOURw",
  updateData: "DAGxYDluMYU/LGIWtKqOYigzMJMpIAHCwg",
  catalistOnly: "DAGxTVpNBkA/92k3F-8uzJKPwZwSbTMk8g",
  downloadData: "DAGxX5NmSXo/hqeb3sqsWD0QPXgLeUaQ4A",
  bestPractices: "DAGyak7tkSE/_vn8Tqu5N4PHktjLT0oOYw",
  fieldDefinitions: "DAGxSAr0twI/MYV11FitJ31BspwrZLlv_A",
  glossary: "DAGvOsE5MdY/REjj3HRX_KyG4v5DKx2X0A",
  latestFeatures: "DAG0qZHQYY0/hFtfk8z1ejiORIeBDL5x5w",
  politicalDataUpload: "DAG-OdmPV7Y/NATjEcGYTFKlQQRC-mcooQ",
  politicalDataReturn: "DAHLESnHoQY/TXGTHc7S67cnfUG6rq8XkA",
};
